"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocusFinalElement = useFocusFinalElement;
var _react = require("react");
/* eslint react-hooks/exhaustive-deps: off */

function useFocusFinalElement(_ref) {
  var finalFocusRef = _ref.finalFocusRef,
    whenConditionMatch = _ref.when;
  (0, _react.useEffect)(function focusOnUnmount() {
    var finalFocusEl = finalFocusRef === null || finalFocusRef === void 0 ? void 0 : finalFocusRef.current;
    return function () {
      finalFocusEl === null || finalFocusEl === void 0 || finalFocusEl.focus();
    };
  }, [finalFocusRef, finalFocusRef === null || finalFocusRef === void 0 ? void 0 : finalFocusRef.current]);
  (0, _react.useEffect)(function focusWhenConditionMatch() {
    if (whenConditionMatch) {
      var _finalFocusRef$curren;
      finalFocusRef === null || finalFocusRef === void 0 || (_finalFocusRef$curren = finalFocusRef.current) === null || _finalFocusRef$curren === void 0 || _finalFocusRef$curren.focus();
    }
  }, [whenConditionMatch, finalFocusRef, finalFocusRef === null || finalFocusRef === void 0 ? void 0 : finalFocusRef.current]);
}